import { useState, useRef } from "react";
import moment from 'moment';
import { useNavigate } from "react-router-dom";
import { useEffect } from "react";
import { useAuth } from "../../context/AuthContext";
import Loading from "./loading";
import { formatDOB } from "../consts/dateMask";
import { setFcwdOnly } from "../../utils/data";
import { countryOptions } from "../../utils/countryOptions";

function Convictions() {
    const {source, token, userState, email, roles} = useAuth();
    const [tableData, setTableData] = useState([]);
    const [validated, setValidated] = useState(false);
    const [errorMessages, setErrorMessages] = useState(['', '']);
    const [formData, setFormData] = useState({
        Header: {
            Metadata: {
                UserID: email //to be replaced with db email
            }
        },
        Body: {
            Source:{
                DataSource: source
            },
            JurisdictionCodeConvicting: userState,
            StartDate: "",
            EndDate: ""
        }
    });
    const [loading, setLoading] = useState(false);
    const [requestSent, setRequestSent] = useState(false);
    const navigate = useNavigate();
    const driverRef = useRef(null)

    const handleSubmit = async (e) => {
        e.preventDefault();
        const form = e.target;
        setErrorMessages(['', '']);

        if (form.checkValidity() === false) {
            if(!formData.Body.StartDate){
                setErrorMessages(prev => [prev[0], 'Please enter a Start Date.']);
            }
            if(!formData.Body.EndDate){
                setErrorMessages(prev => [prev[1], 'Please enter an End Date.']);
            }
            if(formData.Body.StartDate && formData.Body.EndDate && moment(formData.Body.EndDate).isBefore(moment(formData.Body.StartDate))){
                setErrorMessages(prev => [prev[1], 'End Date must be equal to or greater than State Date.']);
            }
            e.stopPropagation(); // prevent submit if invalid
        } else {
            console.log(formData);
            setLoading(true);
            try {
                const response = await fetch(`/api/convictions`, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': `Bearer ${token}`
                    },
                    body: JSON.stringify(formData),
                });
                const result = await response.json();
                console.log('API Response:', result);
                setTableData(result?.Convictions || []);
                setLoading(false);
                setRequestSent(true);
            } catch (error) {
                console.error('Error fetching data:', error);
                setLoading(false);
            }
        }
        setValidated(true);
    }
    const handleDataChange = (event) => {
        const { name, value } = event.target;
        setFormData({
            ...formData,
            Body: {...formData.Body, [name]: value}
        });
    }
    const viewDriver = (driverState, driverLicense) => {
        const isFCWD = countryOptions["US"].some(c => c.code === driverState) || countryOptions["OTH"].some(c => c.code === driverState);
        setFcwdOnly(isFCWD);
        navigate(`/driverdetails/${driverState}/${encodeURIComponent(driverLicense)}`);
    }

    const disableKey  = (event) =>{ 
        event.preventDefault();
        const { name, value } = event.target;
        if(formatDOB(value)){
            return;
        }
        setFormData((formData) => ({ ...formData, [name]: 0 }));
    }


  return (
    <><div className="App">
          <form className={`needs-validation ${validated ? "was-validated" : ""}`} id="Index-form" noValidate onSubmit={handleSubmit}>
              <div className="row">
                  <div className="col-md-3">
                      <label for="inputStart" className="form-label"><b><span className="text-danger">*</span> Start Date</b></label>
                      <input type="date" className="form-control is-invalid" 
                          placeholder="MM/DD/YYYY" name='StartDate' onChange={handleDataChange} max={moment().format("YYYY-MM-DD")}
                          onKeyDown={(e) => disableKey(e)}
                          pattern='(0[1-9]|1[1,2])(\/|-)(0[1-9]|[12][0-9]|3[01])(\/|-)(19|20)\d{2}' required />
                      <div className="invalid-feedback">{errorMessages[0]}</div>

                  </div>
                  <div className="col-md-3">
                      <label for="inputEnd" className="form-label"><b><span className="text-danger">*</span> End Date</b></label>
                      <input type="date" className="form-control is-invalid" 
                          placeholder="MM/DD/YYYY" name='EndDate' onChange={handleDataChange} min={formData.Body.StartDate} max={moment().format("YYYY-MM-DD")}
                          onKeyDown={(e) => disableKey(e)}
                          pattern='(0[1-9]|1[1,2])(\/|-)(0[1-9]|[12][0-9]|3[01])(\/|-)(19|20)\d{2}' required />
                        <div className="invalid-feedback">{errorMessages[1]}</div>

                  </div>
                  <div className="col-md-5">
                        <button type="submit" className="btn btn-primary" id="button" form='Index-form' style={{"textAlign": "start"}}>Get Convictions</button>

                    </div>
              </div>
          </form>
      </div>
      {loading &&
            <Loading />}
      {requestSent && tableData.length > 0 ?
      <div className=" App table-scroll-container" id="table">
        <table class="table table-striped table-bordered">
        <thead class="table-header sticky-header">
            <tr>
            <th scope="col">Action</th>
            <th scope="col">Driver State</th>
            <th scope="col">Driver License</th>
            <th scope="col">Citation Date</th>
            <th scope="col">Conv Date</th>
            <th scope="col">Conv ID</th>
            <th scope="col">SOC</th>
            <th scope="col">Court Type</th>
            <th scope="col">ACD</th>
            <th scope="col">Detail</th>
            <th scope="col">CDL</th>
            <th scope="col">CMV</th>
            <th scope="col">Haz Mat</th>
            <th scope="col">Conv Offense Loc</th>
            <th scope="col">State Native Code</th>
            <th scope="col">Category</th>
            <th scope="col">User ID</th>
            <th scope="col">Date Posted</th>
            </tr>
        </thead>
        <tbody>
            {tableData.map((row, index) => (
            <tr>
                
            <td>
                <button className="btn btn-link" onClick={() => viewDriver(row.driver_state, row.driver_license_number)} 
                style={{ padding: 0, border: "none", background: "none" }}
                >View</button>
            </td>
            <td>{row.driver_state}</td>
            <td>{row.driver_license_number}</td>
            {/* <td>{moment(row.conviction_citation_date).format("MM-DD-YYYY")}</td>
            <td>{moment(row.conviction_date).format("MM-DD-YYYY")}</td> */}
            <td>{row.conviction_citation_date}</td>
            <td>{row.conviction_date}</td>
            <td>{row.conviction_id}</td>
            <td>{row.conviction_jurisdiction_code}</td>
            <td>{row.conviction_court_type}</td>
            <td>{row.conviction_acd_code}</td>
            <td>{row.conviction_acd_code_detail}</td>
            <td>{row.conviction_driver_cdl_holder}</td>
            <td>{row.conviction_commercial_vehicle}</td>
            <td>{row.conviction_hazmat_vehicle}</td>
            <td>{row.conviction_court_locator}</td>
            <td>{row.conviction_juris_offense_reference}</td>
            <td>{row.conviction_category}</td>
            <td>{row.conviction_userid}</td>
            <td>{moment(row.conviction_date_posted).format("MM/DD/YYYY h:mm:ss A")}</td>
            </tr>
            ))}
        </tbody>
        </table>
      </div> : (requestSent &&
      <div class="alert alert-danger" role="alert" style={{"width":"100%", "margin":"auto", "textAlign":"center"}}>
            No Records to show.
        </div> 
      )
}
    </>
  );
}
export default Convictions;